<!--suppress ALL -->
<script lang="ts">
import {sudahBelums} from '../../../util/PluralVariabels';
import {Component, Vue, Prop} from 'annotation';
import {cloneArray} from "../../../util/Underscore";

import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';

@Component
export default class SudahBelumSelect extends Vue {

  @Prop({default: sudahBelums[0], type: String})
  public status: string;

  @Prop({default: false, type: Boolean})
  public skipLabel: boolean;

  @Prop({default: true, type: Boolean})
  public isFullwidth: boolean;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  @Prop({type: Boolean, default: false})
  public disabled: any;

  @Prop({
    default: () => 'Status',
    type: String
  })
  public label: string;

  public onSelectRegistrasi(param: string) {
    this.$emit('update:status', param || sudahBelums[0].value);
    this.$emit('status-selected', param);
  }

  public render(createElement: Function) {
    const {$t, status, isFullwidth, label, message, type} = this;

    const mainAttr: any = {
      attrs: {disabled: this.disabled},
      props: {
        value: status, isFullwidth,
        placeholder: `${$t('label.choose')} status`
      },
      on: {change: this.onSelectRegistrasi}
    };

    const main: any = createElement(GSelect, mainAttr, cloneArray(sudahBelums).map((item: any) => {
      const option: any = {attrs: {value: item.value}};

      return createElement('option', option, item.label);
    }));

    if (this.skipLabel) {
      return main;
    }

    return createElement(GField, {props: {label, message, type}}, [main]);
  }
}
</script>
